'use strict';

var util = require('./util');

module.exports = SchemaObject;

function SchemaObject(obj) {
  util.copy(obj, this);
}



//////////////////
// WEBPACK FOOTER
// ./~/react-jsonschema-form/~/ajv/lib/compile/schema_obj.js
// module id = 353
// module chunks = 0